<script lang="ts">
  import type { Token } from '$lib/interfaces';
  import ItemGrid from './ItemGrid.svelte';
  import LottieSad from './lottie/LottieSad.svelte';
  import TokenViewer from './TokenViewer.svelte';

  export let tokens: Token[] | undefined;
  export let currentPage = 1;
  export let hasNext = false;
</script>

<ItemGrid items={tokens} {currentPage} {hasNext} on:change let:item>
  <TokenViewer token={item} hoverEffects />

  <div slot="empty">
    <LottieSad className="w-6 h-6 mb-2" />
    <br />

    {#if currentPage > 1}
      No more results
    {:else}
      Nothing here yet
    {/if}
  </div>
</ItemGrid>
